import clsx from 'clsx';
import { FC } from 'react';
import { IconSVG } from 'atoms/IconSVG';
import { Link } from 'atoms/Link/Link';
import { AppRoutes } from 'modules/shop/routes';
import styles from './header-icon.module.css';

export const SearchIcon: FC<{
  className?: string;
  color?: 'black' | 'white';
  imgClassName?: string;
}> = ({ className, color = 'black', imgClassName }) => {
  return (
    <Link href={AppRoutes.SEARCH} className={clsx(styles.icon, className)}>
      <IconSVG
        type="search"
        className={clsx(styles.invertIcon, className, styles[color])}
        imgClassName={imgClassName}
      />
    </Link>
  );
};
